/*
# Censimento Font

## Families
- Open sans
- Roboto
- Helvetica
- Verdana

## Weights:
- 300
- 400
- 500
- 600
- 700

## Styles:
- Italic
*/
import openSans300 from "@fontsource/open-sans/files/open-sans-latin-300-normal.woff2?url";
import openSans300Italic from "@fontsource/open-sans/files/open-sans-latin-300-italic.woff2?url";
import openSans400 from "@fontsource/open-sans/files/open-sans-latin-400-normal.woff2?url";
import openSans400Italic from "@fontsource/open-sans/400-italic?url";
import openSans500 from "@fontsource/open-sans/500?url";
import openSans500Italic from "@fontsource/open-sans/500-italic?url";
import openSans600 from "@fontsource/open-sans/600?url";
import openSans600Italic from "@fontsource/open-sans/600-italic?url";
import openSans700 from "@fontsource/open-sans/700?url";
import openSans700Italic from "@fontsource/open-sans/700-italic?url";

import roboto300 from "@fontsource/roboto/300?url";
import roboto300Italic from "@fontsource/roboto/300-italic?url";
import roboto400 from "@fontsource/roboto/400?url";
import roboto400Italic from "@fontsource/roboto/400-italic?url";
import roboto500 from "@fontsource/roboto/500?url";
import roboto500Italic from "@fontsource/roboto/500-italic?url";
import roboto600 from "@fontsource/roboto/600?url";
import roboto600Italic from "@fontsource/roboto/600-italic?url";
import roboto700 from "@fontsource/roboto/700?url";
import roboto700Italic from "@fontsource/roboto/700-italic?url";

export const fonts = [
  {
    id: "open-sans-300",
    url: openSans300,
    preload: false,
  },
  {
    id: "open-sans-300-italic",
    url: openSans300Italic,
    preload: false,
  },
  {
    id: "open-sans-400",
    url: openSans400,
    preload: false,
    // preload: true,
  },
  {
    id: "open-sans-400-italic",
    url: openSans400Italic,
    preload: false,
    // preload: true,
  },
  {
    id: "open-sans-500",
    url: openSans500,
    preload: false,
  },
  {
    id: "open-sans-500-italic",
    url: openSans500Italic,
    preload: false,
  },
  {
    id: "open-sans-600",
    url: openSans600,
    preload: false,
  },
  {
    id: "open-sans-600-italic",
    url: openSans600Italic,
    preload: false,
  },
  {
    id: "open-sans-700",
    url: openSans700,
    preload: false,
  },
  {
    id: "open-sans-700-italic",
    url: openSans700Italic,
    preload: false,
  },
  {
    id: "roboto-300",
    url: roboto300,
    preload: false,
  },
  {
    id: "roboto-300-italic",
    url: roboto300Italic,
    preload: false,
  },
  {
    id: "roboto-400",
    url: roboto400,
    preload: false,
    // preload: true,
  },
  {
    id: "roboto-400-italic",
    url: roboto400Italic,
    preload: false,
    // preload: true,
  },
  {
    id: "roboto-500",
    url: roboto500,
    preload: false,
  },
  {
    id: "roboto-500-italic",
    url: roboto500Italic,
    preload: false,
  },
  {
    id: "roboto-600",
    url: roboto600,
    preload: false,
  },
  {
    id: "roboto-600-italic",
    url: roboto600Italic,
    preload: false,
  },
  {
    id: "roboto-700",
    url: roboto700,
    preload: false,
  },
  {
    id: "roboto-700-italic",
    url: roboto700Italic,
    preload: false,
  },
] as const;
